// extracted by mini-css-extract-plugin
export default {"history":"index_history_ysMvM"};